import React, { useEffect, useState } from "react";
import {
  CircularProgress,
  IconButton,
  Alert, 
  AlertTitle,
  Tooltip,
  Backdrop,
} from "@mui/material";
import { Theme, useTheme } from '@mui/material/styles'
import { createStyles, makeStyles } from '@mui/styles';
import BallotIcon from "@mui/icons-material/Ballot";

import { useLocalStorage } from "../../utils/LocalStorageHook";
import { getRequests, flattenRequests, deleteRequest } from "../../utils/GetRequest";
import ResponsiveDrawer from "../../components/ClippedResponsiveDrawer";
import requestMissingContexts, { determineConfig } from "../../utils/GetContext";
import TableAbstraction from "../../componentUtils/TableAbstraction"
import {checkForRole} from "../../utils/GetAuth";
import PageInPage from "../../componentUtils/PageInPage";
import { removeLeadingZeros, formatDate } from "../../utils/Formatter";
import RecommendationComponent from "../../components/request/Recommend";

import {
  Lock,
 } from '@mui/icons-material';
import VendPrimeRequest from "./VendPrimeRequest";
import { GetStatusBadge } from "../../components/request/requestUtils";
import DeleteIcon from "@mui/icons-material/Delete";
import { GridFilterInputValue, GridFilterItem, GridFilterModel, GridLinkOperator, GridStateColDef } from "@mui/x-data-grid-pro";
import { saveSettingsData } from "src/utils/GetSettingsData";

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    centerDiv: {
      textAlign: "center",
    },
    root: {},
    divWidth: {
      width: "100%",
    },
    paper: {
        position: 'absolute',
        backgroundColor: theme.palette.background.paper,
        border: `1px solid`,
        borderColor: theme.palette.border.main, 
        boxShadow: theme.shadows[4],
        padding: theme.spacing(2, 2, 2),
    },
    iconRed: {
      color: "Crimson",
      fontSize: 13,
    },
    iconYellow: {
      color: "Gold",
      fontSize: 13,
    },
    iconGreen: {
      color: "LimeGreen",
      fontSize: 13,
    },
    iconDisabled: {
      color: "LightGray",
      fontSize: 13,
    },
  })
);

interface Data {
  requestStatus: any[];
}
export default function VendPrimeRequestMonitor() {
  const classes = useStyles();
  const [vpRequests, SetVpRequests] = useState<any[]>([]);
  const [percentileConsumption, setPercentileConsumption] = useState<any>();
  const [reqmoniterenable, setReqmoniterenable] =  React.useState<boolean>(true);
  const [codes, setCodes] = React.useState<any>();
  const [salesOrg,] = useLocalStorage("SETTINGS.salesOrg", "");
  const [doneLoading, setDoneLoading] = React.useState<boolean>(false);
  const [clientId,] = useLocalStorage("SETTINGS.clientId", 100);
  const enabled = checkForRole(`${clientId}`,salesOrg,'vp_access');
  
  const header =  document.querySelector('ResponsiveDrawer')
  const headerAdj = header?header.clientHeight:200;
  const [TABLE_BODY_HEIGHT, setTABLE_BODY_HEIGHT] = React.useState<string>(`${window.innerHeight - headerAdj }px`);
  window.addEventListener('resize', ()=>{
    setTABLE_BODY_HEIGHT(`${window.innerHeight - headerAdj }px`);
  })


  const [muiTable, setMuiTable] = React.useState<any>({rpp:25});
  const [displayREC, setDisplayREC] = React.useState<boolean>(false);
  const [displayPIP, setDisplayPIP] = React.useState<boolean>(false);
  const [curKeys, setCurKeys] = React.useState<{requestNum:number,deliveringPlant:string,masterRoute:string,customerNum:string,customerName:string}|undefined>();
  const [showReco, setShowReco] = useState<any>({});
  const [date,setDate]=useState("");
  const [activity,setActivity]=useState("");
  const [progress,setProgress]=useState(false);

  const dataMap = (arr: string[]): string[] => {
    return Array.from(new Set(arr));
  };
  const rowData = vpRequests;
  let  requestStatus,filterDropDowns: Data;
  const filterData = () => {
    if (rowData) {
      requestStatus = dataMap(rowData.map((s) => s.requestStatus));
      filterDropDowns = { requestStatus};
      filterDropDowns.requestStatus = filterDropDowns.requestStatus.map((s) => {
        const obj: { code: string; text: string } = { code: s, text: "" };
        if (s === "O") obj.text = "Open";
        if (s === "VP_ACCEPT") obj.text = "Accepted";
        if (s === "C") obj.text = "Cancelled";
        if (s === "VP_AS_IS") obj.text = "No Change To Config";
        if (s === "VP_SUBMIT") obj.text = "Submitted";
        if (s === "VP_QUEUE") obj.text = "Pending Approval";
        if (s === "S") obj.text = "Successfully completed";
        if (s === "VP_DRAFT") obj.text = "Draft";
        if (s === "VP_REJECT") obj.text = "Rejected";
        if (s === "VP_REQUST") obj.text = "Requested";
        if (s === "I") obj.text = "In process";
        if (s === "M") obj.text = "Mobile completed";
        if (s === "Y") obj.text = "Partially Completed";
        if (s === "!") obj.text = "Not found";
        if (s === "Z") obj.text = "Not completed";
        return obj;
      });

      
      return filterDropDowns;
    }
  };
  filterData();
  
  useEffect(() => {
    if (doneLoading===true) {
      return;
    }
    if (!doneLoading){
      requestMissingContexts(["SALESOFFICES","PLANTS","vp_req_status"])
      .then((v) => {
        setCodes(v);
      })
      .then((_) => {
          getRequests(salesOrg,{}).then((v) => {
            if(v && v.requests){
              let temp:any[] = v.requests;
              SetVpRequests(flattenRequests(temp));
            }
            if(v && v.PercentileMaterialConsumption){
              setPercentileConsumption(v.PercentileMaterialConsumption)
  
            }
            setDoneLoading(true);
          });
      });
    }
  }, [ muiTable, displayPIP, doneLoading, salesOrg]);

  const handleDeleteDraft = (tableMeta: any) => {
    deleteRequest(salesOrg, tableMeta?.requestNum)
    .then((v) => {
      const newVpRequests=vpRequests.filter(i => i.requestNum !==  tableMeta?.requestNum);
      SetVpRequests(newVpRequests);
      setDoneLoading(false)
    })
  }

  function handleUndefined(params: any, filterItem: GridFilterItem): boolean {
    if (!filterItem.value) {
      filterItem.value = params.value;
      return params.value === filterItem.value;
    }
      return params.value === filterItem.value;
  }

  useEffect(()=>{
    if (date!=undefined&&date!="") {
    setProgress(true);
    SetVpRequests([]); // Clear existing data
      getRequests(salesOrg,{requested_dt:date,activity:activity}).then((v) => {
        if(v && v.requests){
          setProgress(false);
          let temp:any[] = v.requests;
          SetVpRequests(flattenRequests(temp));
        }
        if(v && v.PercentileMaterialConsumption){
          setPercentileConsumption(v.PercentileMaterialConsumption)
        }
        setDoneLoading(true);
      });
    }
  },[date])

let callPi=(targetDate:any)=>{
  if (targetDate.item) {
    setDate(targetDate.item['value']);
    setActivity(targetDate.item['operatorValue']);
  }else{
    setDate(targetDate['value']);
    setActivity(targetDate['operatorValue']);
  }
}

  return (
    <ResponsiveDrawer
      title="Request Monitor"
    >
    <div className={classes.root}>
      {doneLoading && enabled? (
        <TableAbstraction
          settingsKey="VP_RM"
          options={{
            draggableColumns: {
              enabled: true,
            },
            rowsPerPageOptions: [25, 50, 100],
            serverSide: false,
            selectableRows: "none",
            rowsPerPage: muiTable.rpp,            
            onChangeRowsPerPage: (numberOfRows) => {
              muiTable.rpp = numberOfRows;
              setMuiTable(muiTable);
            },
            onRowClick: (params) =>{
              setCurKeys({
                requestNum:params.row.requestNum,
                deliveringPlant:params.row.plant,
                masterRoute:params.row.masterRoute,
                customerNum:params.row.customerNum,
                customerName:params.row.name1 + ' [' + params.row.name3 +']'
              });
              setDisplayPIP(true);
            }
          }}
          title="Request Monitor"
          columns={[
            {
              label: "Request Num",
              name: "requestNum",
              options: {
                searchable: true,
                filter: true,
              },
            },
            {
              label: "Request Date",
              name: "requestedDt",
              options: {
                searchable: true,
                filter: true,
                type:'date',
                filterOperators: [
                  {
                    getApplyFilterFn: (filterItem: GridFilterItem,column: GridStateColDef<any, any, any>) => {
                      return (params): any => {
                      callPi(filterItem)
                        return true;
                      };
                    },
                    label: "is",
                    value: "=",
                    InputComponent: (props: any) => {
                      callPi(props)
                      return (
                        <div>
                        <GridFilterInputValue type="date"  {...props}/>
                        </div>)
                    },
                  },
                  {
                    getApplyFilterFn: (filterItem: GridFilterItem,column: GridStateColDef<any, any, any>) => {
                      return (params): any => {
                      callPi(filterItem)
                        return true;
                      };
                    },
                    label: "is not",
                    value: "!=",
                    InputComponent: (props: any) => {
                      callPi(props)
                      return (
                        <div>
                        <GridFilterInputValue type="date"  {...props}/>
                        </div>)
                    },
                  },
                  {
                    getApplyFilterFn: (filterItem: GridFilterItem,column: GridStateColDef<any, any, any>) => {
                      return (params): any => {
                      callPi(filterItem)
                        return true;
                      };
                    },
                    label: "is after",
                    value: ">",
                    InputComponent: (props: any) => {
                      callPi(props)
                      return (
                        <div>
                        <GridFilterInputValue type="date"  {...props}/>
                        </div>)
                    },
                  },
                  {
                    getApplyFilterFn: (filterItem: GridFilterItem,column: GridStateColDef<any, any, any>) => {
                      return (params): any => {
                      callPi(filterItem)
                        return true;
                      };
                    },
                    label: "is on or after",
                    value: ">=",
                    InputComponent: (props: any) => {
                      callPi(props)
                      return (
                        <div>
                        <GridFilterInputValue type="date"  {...props}/>
                        </div>)
                    },
                  },
                  {
                    getApplyFilterFn: (filterItem: GridFilterItem,column: GridStateColDef<any, any, any>) => {
                      return (params): any => {
                      callPi(filterItem)
                        return true;
                      };
                    },
                    label: "is before",
                    value: "<",
                    InputComponent: (props: any) => {
                      callPi(props)
                      return (
                        <div>
                        <GridFilterInputValue type="date"  {...props}/>
                        </div>)
                    },
                  },
                  {
                    getApplyFilterFn: (filterItem: GridFilterItem,column: GridStateColDef<any, any, any>) => {
                      return (params): any => {
                      callPi(filterItem)
                        return true;
                      };
                    },
                    label: "is on or before",
                    value: "<=",
                    InputComponent: (props: any) => {
                      callPi(props)
                      return (
                        <div>
                        <GridFilterInputValue type="date"  {...props}/>
                        </div>)
                    },
                  },
                ],
              },
            },
            {
              label: "Status",
                  name: "requestStatus",
                  options: {
                    searchable: false,
                    filter: true,
                    customBodyRender: (value: any) =>  (<GetStatusBadge status={value} codes={codes} />),
                    filterOperators: [
                      {
                        getApplyFilterFn: (filterItem: GridFilterItem) => {
                          return (params): boolean => {
                            return handleUndefined(params, filterItem);
                          };
                        },
                        label: "equals",
                        value: "requestStatus",
                        InputComponent: (props: any) => (
                          <GridFilterInputValue select SelectProps={{ native: true }} {...props}>
                            {filterDropDowns.requestStatus.map((v: any) => (
                              <option value={v.code}>{v.text}</option>
                            ))}
                          </GridFilterInputValue>
                        ),
                      },
                      {
                        getApplyFilterFn: (filterItem: GridFilterItem) => {
                          return (params): boolean => {
                            return params.value !== filterItem.value;
                          };
                        },
                        label: "not equals",
                        value: "requestStatus_neq",
                        InputComponent: (props: any) => (
                          <GridFilterInputValue select SelectProps={{ native: true }} {...props}>
                            {filterDropDowns.requestStatus.map((v: any) => (
                              <option value={v.code}>{v.text}</option>
                            ))}
                          </GridFilterInputValue>
                        ),
                      },
                    ],
                  },
                },
            {
              label: "Requested By",
              name: "requestedBy",
              options: {
                searchable: true,
                filter: true,
              },
            },
            {
              label: "Execution Date",
              name: "executionDt",
              options: {
                searchable: true,
                filter: false,
                customBodyRender: (value: any) => {return `${value?formatDate(value):""}`} ,
              },
            },
            {
              label: "Customer",
              name: "customerNum",
              options: {
                searchable: true,
                filter: true,
              },
            },
            {
              label: "Name",
              name: "customerName1",
              options: {
                searchable: true,
                filter: true,
              },
            },
            {
              label: "Sales Office",
              name: "salesOffice",
              options: {
                filter: true,
                customBodyRender: (value: any) => `${value} - ${determineConfig(codes, "SALESOFFICES", value)}` ,
              },
            },
            {
              label: "Delivery Plant",
              name: "plant",
              options: {
                filter: true,
                customBodyRender: (value: any) => `${value} - ${determineConfig(codes, "PLANTS", value)}` ,
              },
            },
            
            {
              label: "Route",
              name: "masterRoute",
              options: {
                searchable: true,
                filter: true,
              },
            },
            {
              label: "Model",
              name: "model",
              options: {
                searchable: true,
                filter: false,
              },
            },
            {
              label: "Opt Type",
              name: "optimizationType",
              options: {
                searchable: true,
                filter: false,
              },
            },
            {
              label: "SAP Num",
              name: "sapRequestNumber",
              options: {
                searchable: true,
                filter: true,
              },
            },
            {
              label: "Last Change",
              name: "maxDt",
              options: {
                searchable: true,
                filter: false,
              },
            },
            {
              label: "Reco",
              name: "guid",
              options: {
                searchable: true,
                filter: false,
                customBodyRender: (value:any)=>{
                  let customerInfo = vpRequests.find(
                    (v: any) => v.guid === (value as any)
                  );
                  if (customerInfo.origRequestNum != null) {
                      return( <IconButton
                        onClick={() => {
                         // console.log(customerInfo)
                          setShowReco(customerInfo);
                          setDisplayREC(true);
                        }}
                      >
                        
                        <BallotIcon fontSize="small" />
                      </IconButton>
                      )
                  } else {
                       return <div />;
                  }
              }
              },
            },
            {
              label: "Delete",
              name: "delete",
              options: {
                filter: false,
                setCellProps: () => ({ align: 'right' }),
                renderCell: (props:any) => {
                  const tableMeta = props.row;
                 if(tableMeta?.requestStatus === 'VP_DRAFT' || tableMeta?.requestStatus === 'VP_AS_IS') {
                    return (
                      <React.Fragment>
                          <Tooltip title={"Delete"}>
                            <IconButton
                              onClick={(e) => {
                                e.stopPropagation();
                                handleDeleteDraft(tableMeta);
                              }}
                            >
                              <DeleteIcon color="primary"/>
                            </IconButton>
                          </Tooltip>  
                      </React.Fragment>
                    )
                  }
                }
              },
            },
          ]}
          data={vpRequests}
          vpRMfiltersData= {reqmoniterenable}
        />
      ) : ( enabled ? (
        <div className={classes.centerDiv}>
          <CircularProgress color="primary" />
        </div>) : (
          <Alert severity="error">
            <AlertTitle><Lock/> Access Error</AlertTitle>   
            You do not currently have access to <strong>Vend Prime</strong> activities for the <strong>{salesOrg}</strong> bottler. 
          </Alert>
        )
      )}
      <PageInPage onClose={()=>{setDisplayPIP(false)}} title={`Delivering Plant: ${curKeys?curKeys?.deliveringPlant:''} Master Route: ${curKeys?curKeys?.masterRoute:''} (${curKeys?curKeys.customerNum:''}) ${curKeys?curKeys.customerName:''}`} isOpen={displayPIP} content={(<VendPrimeRequest requestNum={curKeys?curKeys.requestNum:0} onClose={()=>{ setDoneLoading(false)}} />)} />
      <PageInPage
    onClose={() => {
      setDisplayREC(false);
    }}
    title={`Reconfiguration for ${showReco.deliveringPlant}: ${showReco.customerNum} ${showReco.name1} [${showReco.name3}]`}
    isOpen={displayREC}
    content={
      <RecommendationComponent
        fullpage={false}
        customer={showReco.customerNum}
      />
    }
  />

    </div>
      <Backdrop sx={{ color: "#fff", zIndex: (theme: any) => theme.zIndex.drawer + 1 }} open={progress}>
      <CircularProgress color="primary" />
    </Backdrop>

    </ResponsiveDrawer>
  );
}